import { IconsProps } from './IconsProps';

const Plus = ({
  className = '',
  viewBox = '0 0 24 24',
  width = 24,
  height = 24,
  onClick,
  svgFill = 'currentColor',
  ariaLabel,
  ariaHidden,
}: IconsProps) => {
  return (
    <svg
      className={className}
      viewBox={viewBox}
      width={`${width}px`}
      height={`${height}px`}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      onClick={onClick}
      fill={svgFill}
      aria-label={ariaLabel}
      aria-hidden={ariaHidden}
    >
      <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
    </svg>
  );
};

export default Plus;
